import { apiFetchJson, apiGet } from './apiClient';

export type AdminUserPermissions = {
  id: string;
  email: string;
  login: string;
  displayName: string | null;
  firstName: string | null;
  lastName: string | null;
  isAdmin: boolean;
  isAnalystLegacy: boolean;
  canEditRecords: boolean;
  canGradeRecords: boolean;
};

export async function fetchAdminUserPermissions(params?: {
  search?: string;
  page?: number;
  limit?: number;
}): Promise<{ data: AdminUserPermissions[]; total: number; page: number; limit: number }> {
  const query = new URLSearchParams();
  if (params?.search) query.set('search', params.search);
  if (params?.page) query.set('page', String(params.page));
  if (params?.limit) query.set('limit', String(params.limit));
  const suffix = query.toString() ? `?${query.toString()}` : '';
  const res = await apiGet<{ data: AdminUserPermissions[]; total: number; page: number; limit: number }>(
    `/admin/user-permissions${suffix}`,
  );
  return {
    data: res?.data || [],
    total: res?.total || 0,
    page: res?.page || 1,
    limit: res?.limit || 25,
  };
}

export async function updateAdminUserPermissions(
  userId: string,
  payload: { canEditRecords: boolean; canGradeRecords: boolean },
): Promise<AdminUserPermissions> {
  const res = await apiFetchJson<AdminUserPermissions>('PUT', `/admin/user-permissions/${userId}`, {
    body: payload,
    withAuth: true,
  });
  if (!res.ok) throw new Error(res.error);
  return res.data as AdminUserPermissions;
}

export async function deleteAdminUserAccount(userId: string): Promise<{ ok: boolean; email: string }> {
  const res = await apiFetchJson<{ ok: boolean; email: string }>(
    'DELETE',
    `/admin/user-permissions/${userId}`,
    { withAuth: true },
  );
  if (!res.ok) throw new Error(res.error);
  return res.data as { ok: boolean; email: string };
}

export function formatAdminUserLabel(user: AdminUserPermissions): string {
  const name = [user.lastName, user.firstName].filter(Boolean).join(' ').trim();
  return name || user.displayName || user.login || user.email;
}
